<template><div v-if="showDashboard">
	<div class="form-sticky-container">
		<div class="card-widget form-absolute">
      <div class="d-lg-none collapse-toggle-container text-right">
        <b-row class="justify-content-between align-items-center">
          <b-col cols="auto"class="font-2xl">{{$t('Filters')}}</b-col>
          <b-col cols="auto">
            <button v-on:click="toggleFilters()" class="btn  text-center" type="button" data-toggle="collapse" data-target="#formStickyWidget" aria-expanded="false" aria-controls="formStickyWidget">
              <i v-if="isFiltersOpen" class="fas fa-arrow-up m-0"></i>
              <i v-else class="fas fa-arrow-down m-0"></i>
            </button>
          </b-col>
        </b-row>
      </div>
			<div class="collapse show card-widget-content pb-1 pt-4" id="formStickyWidget">
				<form class="mb-0">
					<b-row class="justify-content-between align-items-center">
						<b-col sm="12" xl="12" class="quick-filters">
							<b-row>
								<b-col cols="auto" class="pl-3 pr-2">
									<div class="form-group">
										<label>{{$t('Quick filters')}}</label>
										<div>
											<button type="button" class="btn btn-light m-1" v-on:click="selectPreRange('today')">{{$t('Today')}}</button>
                                            <button type="button" class="btn btn-light m-1" v-on:click="checkLicense(null, false, 'premium') ? selectPreRange('this_week') : licensePopup('premium')">{{$t('This week')}}</button>
                                            <button type="button" class="btn btn-light m-1" v-on:click="checkLicense(null, false, 'premium') ? selectPreRange('this_month') : licensePopup('premium')">{{$t('This month')}}</button>
										</div>
									</div>
								</b-col>
							</b-row>
						</b-col>
						<b-col cols="12" sm="12" md="12" lg="10" xl="8" class="center-filter-col">
							<div class="form-row">
								<div class="col-12 col-sm-6 col-md-3">
									<div class="form-group">
										<label>{{$t('Start date')}}:</label>
										<div class="input-group mr-sm-2">
											<div class="input-group-prepend">
												<div class="input-group-text"><i class="fas fa-calendar-alt"></i></div>
											</div>
											<b-form-input type="date" v-model="datepickerconfig.dateStart" :min="licenseMinStatsRange" :max="moment().format('YYYY-MM-DD')" @change="listenToOnStartChangeEvent"></b-form-input>
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-6 col-md-3">
									<div class="form-group">
										<label>{{$t('End date')}}: </label>
										<div class="input-group mr-sm-2">
											<div class="input-group-prepend">
												<div class="input-group-text"><i class="fas fa-calendar-alt"></i></div>
											</div>
											<input type="date" v-model="datepickerconfig.dateEnd" :min="licenseMinStatsRange" :max="moment().format('YYYY-MM-DD')" v-on:selected="listenToOnEndChangeEvent" class="form-control">
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-6 col-md-3">
									<div class="form-group" v-on:click="checkLicense($event, true, 'premium')">
										<label>{{$t('Stores')}}</label>
										<b-form-select v-model="storeId" class="form-control" @input="onStoreChange" :disabled="stores.length<1 || !checkLicense(null, false, 'premium')">
											<option value="0" selected>{{$t('All')}}</option>
											<option :value="store.id" v-for="store in stores" :key="store.id">{{store.name}}</option>
										</b-form-select>
									</div>
								</div>
								<div class="col-12 col-sm-6 col-md-3">
									<div class="form-group" v-on:click="checkLicense($event, true, 'premium')">
										<label>{{$t('POS')}}</label>
										<b-form-select v-model="posId" class="form-control" @input="onPOSChange" :disabled="pos.length<1 || !checkLicense(null, false, 'premium')">
											<option value="0" selected>{{$t('All')}}</option>
											<option :value="cassa.id" v-for="cassa in pos" :key="cassa.id">{{cassa.name}}</option>
										</b-form-select>
									</div>
								</div>
							</div>
						</b-col>
						<b-col cols="12" sm="12" md="12" lg="2"  xl="2" class="filter-submit-button-col">
							<b-row>
								<div class="col-md-12">
									<div class="form-group text-center text-md-right">
										<label class="d-xl-block">&nbsp;</label>
										<button type="button" class="btn btn-success w-100 filter-submit-button" v-on:click="setFilters()">{{$t('Update')}}</button>
									</div>
								</div>
							</b-row>
						</b-col>
					</b-row>
				</form>
			</div>
		</div>
	</div>

<!-- start: avvisi -->
	<b-row class="after-fixed-row" style="">
        <b-col v-if="!!this.$store.getters['services/e_invoice'].fea_required && !this.$store.getters['services/e_invoice'].fea_signed && e_service_days_active > 7" cols="12" class="mt-3 mb-2">
            <div class="alert alert-danger py-3" role="alert">
                {{$t('To complete the activation of the electronic invoicing service')}} <router-link :to="{name: 'EInvoiceFea'}" >{{$t('click here')}}</router-link>.
            </div>
        </b-col>
        <b-col v-if="!!this.$store.getters['services/e_invoice'].fea_required && !this.$store.getters['services/e_invoice'].fea_signed && e_service_days_active <= 7" cols="12" class="mt-3 mb-2">
            <div class="alert alert-warning py-3" role="alert">
                {{$t('To complete the activation of the electronic invoicing service')}} <router-link :to="{name: 'EInvoiceFea'}" >{{$t('click here')}}</router-link>.
            </div>
        </b-col>
        <b-col v-if="$store.getters['services/e_invoice'] && $store.getters['services/e_invoice'].status === 'company_data_error'" cols="12" class="mt-3 mb-2">
            <div class="alert alert-danger py-3" role="alert">
                {{$t('There is an error with the company data, to correct them and continue with the activation of the electronic invoicing service')}} <router-link :to="{name: 'EInvoiceActivation'}" >{{$t('click here')}}</router-link>.
            </div>
        </b-col>
        <div v-if="$store.getters['services/e_invoice'] && ['activating', 'activation_error'].includes($store.getters['services/e_invoice'].status)" class="col-md-12 col-sm-12 mt-3 mb-2">
            <div class="alert alert-info py-3">
                {{ $t('RCH InvoiceBox service activation in progress.') }}
            </div>
        </div>
        <b-col v-if="$store.getters['services/e_invoice'] && invoices_unpaid_count > 0" cols="12" class="mt-3 mb-2">
            <div class="alert alert-warning py-3" role="alert">
                {{$tc('unpaid_invoices_count_alert', invoices_unpaid_count)}} <router-link :to="{name: 'Documents'}" >{{$t('click here')}}</router-link>.
            </div>
        </b-col>
        <div class="col col-12 mt-3">
            <div class="alert alert-warning alert-dismissible mb-2 h-auto" v-if="isTrialLicenseExpiring() && available_alert_ids.includes('xstore_license_trial_expiring')">
                <strong>{{ $t('Warning') }}! </strong>
                <span>{{ $t('Il periodo di prova della tua licenza XStore Enterprise sta per scadere. Rinnova la licenza per continuare a utilizzare tutte le funzionalità incluse nel profilo Enterprise. Per scoprire le differenze tra le licenze,') }} </span>
                <button type="button" class="btn btn-link p-0" v-b-modal.license-compare-modal>{{ $t('click here') }}.</button>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="dismissLicenseAlert('xstore_license_trial_expiring')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="alert alert-warning alert-dismissible mb-2 h-auto" v-if="isTrialLicenseExpired() && available_alert_ids.includes('xstore_license_trial_expired')">
                <strong>{{ $t('Warning') }}! </strong>
                <span>{{ $t('II periodo di prova della tua licenza XStore Enterprise è scaduto. Per scoprire i vantaggi della licenza Enterprise,') }} </span>
                <button type="button" class="btn btn-link p-0" v-b-modal.license-compare-modal>{{ $t('click here') }}.</button>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="dismissLicenseAlert('xstore_license_trial_expired')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="alert alert-warning alert-dismissible mb-2 h-auto" v-if="isLicenseExpired('premium') && available_alert_ids.includes('xstore_license_premium_expired')">
                <strong>{{ $t('Warning') }}! </strong>
                <span>{{ $t('La tua licenza XStore Premium è scaduta. Per riattivarla ') }} </span>
                <a :href="`${$xmarket_url}/prodotto/licenza-xstore-enterprise`">{{ $t('go to XMarket') }}.</a>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="dismissLicenseAlert('xstore_license_premium_expired')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="alert alert-warning alert-dismissible mb-2 h-auto" v-if="isLicenseExpired('enterprise') && available_alert_ids.includes('xstore_license_enterprise_expired')">
                <strong>{{ $t('Warning') }}! </strong>
                <span>{{ $t('La tua licenza XStore Enterprise è scaduta. Per riattivarla ') }} </span>
                <a :href="`${$xmarket_url}/prodotto/licenza-xstore-enterprise`">{{ $t('go to XMarket') }}.</a>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="dismissLicenseAlert('xstore_license_enterprise_expired')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
		<b-col md="8">
			<div class="row py-2">
				<div class="col-6 col-md">
					<router-link  :to="{name: null}">
						<div class="stats stats-success">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3><i class="fas fa-hand-holding-usd"></i> {{$t('Cash')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{cash.totale | formatPriceExt(currency_label)}}</h3>
								</div>
								<!--
                                <div class="col-auto">
                                    <span class="card_cta"><span class="mr-2">{{$t('View')}}</span><i class="fas fa-eye"></i></span>
                                </div>
                                -->
							</div>
						</div>
					</router-link>
				</div>

				<div class="col-6 col-md">
					<router-link  :to="{name: 'Documents'}">
						<div class="stats stats-info have-link">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3><i class="fas fa-file"></i> {{$t('Issued documents')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{cash.docs}}</h3>
								</div>
								<div class="col-auto">
									<span class="card_cta"><span class="mr-2">{{$t('View')}}</span><i class="fas fa-eye"></i></span>
								</div>
							</div>
						</div>
					</router-link>
				</div>

				<div class="col-6 col-md mt-1 mt-md-0">
					<router-link  :to="{name: null}">
						<div class="stats stats-warning">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3><i class="fas fa-file-invoice"></i> {{$t('Receipt\'s average')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{averageBill | formatPriceExt(currency_label)}}</h3>
								</div>
								<!--
                                <div class="col-auto">
                                    <span class="card_cta"><span class="mr-2">{{$t('View')}}</span><i class="fas fa-eye"></i></span>
                                </div>
                                -->
							</div>
						</div>
					</router-link>
				</div>

				<div v-if="$store.getters.getAcls.includes('mkt_it')" class="col-6 col-md mt-1 mt-md-0">
					<a href="#">
						<div class="stats stats-primary">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3><i class="fas fa-exchange-alt"></i> {{$t('Returns')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{return_docs_tot | formatPriceExt(currency_label)}}</h3>
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		</b-col>
		<b-col md="1" v-if="floor === null" >
		</b-col>
		<b-col>
			<b-row class="py-2 h-100">
				<div v-if="$store.getters.getAcls.includes('mkt_it') && $store.getters.getCustomer.license.license_meta.code !== 'personal'" class="col">
					<router-link  :to="{name: 'Devices'}">
						<div class="stats stats-danger have-link">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3><i class="fas fa-exclamation-triangle"></i> {{$t('Alerts')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{alerts}}</h3>
								</div>
								<div class="col-auto">
									<span class="card_cta"><span class="mr-2">{{$t('View')}}</span><i class="fas fa-eye"></i></span>
								</div>
							</div>
						</div>
					</router-link>
				</div>

				<div  v-if="floor !== null" class="col">
					<a href="#">
						<div class="custom alert alert-warning-outline">
							<div class="card-widget-title">
								<div class="card-widget-title-label">
									<h3>{{$t('Open accounts')}}</h3>
								</div>
							</div>
							<hr>
							<div class="card-widget-content d-flex flex-row justify-content-between no-gutters">
								<div class="col-auto">
									<h3>{{ floor.conti }}</h3>
								</div>
                                <div class="col-auto">
                                    <span class="card_cta">{{ floor.totale | formatPriceExt(currency_label) }}</span>
                                </div>
							</div>
						</div>
					</a>
				</div>
			</b-row>
		</b-col>
	</b-row>
<!-- end:: avvisi -->
	<b-row class="mt-2">
		<b-col sm="12" xl="8" class="h-100">
			<div class="card-widget">
				<div class="card-widget-content pt-4 pb-3">
					<div class="border-bottom text-left">
						<h3 class="font-weight-bold">
							{{$t('Sales by category')}}
							<span class="float-right">
								<i v-if="category_display_mode === 'pie'" @click="category_display_mode = 'table'" class="fas fa-table font-2xl font-weight-light cursor-pointer"></i>
								<i v-else-if="category_display_mode === 'table'" @click="category_display_mode = 'pie'" class="fas fa-chart-pie font-2xl font-weight-lighter cursor-pointer"></i>
							</span>
						</h3>
					</div>
					<div class="row justify-content-around">
						<div class="d-flex justify-content-center m-5" v-if="isBusy">
							<b-spinner label="Loading..."></b-spinner>
						</div>
						<p class="text-center m-5" v-else-if="categorie.length === 0">{{$t('No data available')}}</p>
						<div class="col-md-8 text-center align-self-center"  v-else-if="category_display_mode === 'pie'">
							<div class="chart-wrapper mt-3">
								<pie-chart :chart-data="categorie" :options="opzioni_categorie" ></pie-chart>
							</div>
						</div>
						<div v-else-if="category_display_mode === 'table'" class="row w-100 py-4">
							<div class="col font-weight-bold"
								 :class="categorie.datasets[0].data.length > 1 ? 'col-md-6 col-12' : 'col-md-12'">
								<p>{{$t('Category')}} <span class="float-right">{{$t('Amount')}}</span></p>
							</div>
							<div class="col col-md-6 d-none d-md-block font-weight-bold"
								 v-if="categorie.datasets[0].data.length > 1">
								<p>{{$t('Category')}} <span class="float-right">{{$t('Amount')}}</span></p>
							</div>
							<div class="col"
								 :class="categorie_table.length > 1 ? 'col-md-6 col-12' : 'col-md-12'"
								 v-for="cat in categorie_table">
								<p><span class="badge badge-pill mr-2" style="line-height: 0.6;" :style="{'background-color': cat.color}">&nbsp;</span>{{ cat.label }} <span class="float-right">{{ cat.amount | formatPriceExt(currency_label) }}</span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-col>
		<b-col sm="12" xl="4" class="h-100">
			<div class="card-widget mb-3">
				<div class="card-widget-content pt-4 pb-3">
					<div class="border-bottom text-left"><h3 class="font-weight-bold">{{$t('Best selling products')}}</h3></div>
					<div class="row justify-content-around">
						<div class="col-md-8 text-center align-self-center">
							<div class="d-flex justify-content-center m-3" v-if="isBusy">
								<b-spinner label="Loading..."></b-spinner>
							</div>
							<doughnut-chart v-else-if="top_prod && top_prod.labels" :chart-data="top_prod"></doughnut-chart>
							<p v-else class="text-center mt-4">{{$t('No data available')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="card-widget mb-3">
				<div class="card-widget-content pt-4 pb-3">
					<div class="border-bottom text-left"><h3 class="font-weight-bold">{{$t('Greater income')}}</h3></div>
					<div class="row justify-content-around">
						<div class="col-md-8 text-center align-self-center">
							<div class="d-flex justify-content-center m-3" v-if="isBusy">
								<b-spinner label="Loading..."></b-spinner>
							</div>
							<doughnut-chart v-else-if="greater_prod && greater_prod.labels" :chart-data="greater_prod" :custom-options="greater_prod_tooltip_label_cb"></doughnut-chart>
							<p v-else class="text-center mt-4">{{$t('No data available')}}</p>
						</div>
					</div>
				</div>
			</div>

		</b-col>
	</b-row>
	<b-row>
		<b-col sm="12" xl="6" >
			<div class="card-widget">
				<div class="card-widget-content pt-4 pb-3">
					<div class="border-bottom text-left"><h3 class="font-weight-bold">{{$t('Sales by period')}}</h3></div>
					<div class="row justify-content-end mt-4 no-gutters">
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartSt('hour')" :class="'btn btn-secondary p-1'+(range_chart_st=='hour'?' active':'')">{{$t('Hour')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartSt('day')" :class="'btn btn-secondary p-1'+(range_chart_st=='day'?' active':'')">{{$t('Day')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartSt('week')" :class="'btn btn-secondary p-1'+(range_chart_st=='week'?' active':'')">{{$t('Month')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartSt('month')" :class="'btn btn-secondary p-1'+(range_chart_st=='month'?' active':'')">{{$t('Year')}}</button></div>
					</div>
					<sales-performance-chart ref="sales_tot_chart" v-bind:class="{ 'd-none': !(cash_array && (cash_array.actual))}"></sales-performance-chart>
          <div class="d-flex justify-content-center m-3" v-if="!(cash_array && (cash_array.actual))">
            <b-spinner label="Loading..."></b-spinner>
          </div>
				</div>
			</div>
		</b-col>
		<b-col sm="12" xl="6" >
			<div class="card-widget">
				<div class="card-widget-content pt-4 pb-3">
					<div class="border-bottom text-left"><h3 class="font-weight-bold">{{$t('Average receipt')}}</h3></div>
					<div class="row justify-content-end mt-4 no-gutters">
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartNd('hour')" :class="'btn btn-secondary p-1'+(range_chart_nd=='hour'?' active':'')">{{$t('Hour')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartNd('day')" :class="'btn btn-secondary p-1'+(range_chart_nd=='day'?' active':'')">{{$t('Day')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartNd('week')" :class="'btn btn-secondary p-1'+(range_chart_nd=='week'?' active':'')">{{$t('Month')}}</button></div>
						<div class="col-auto ml-2"><button type="button" v-on:click="selectRangeChartNd('month')" :class="'btn btn-secondary p-1'+(range_chart_nd=='month'?' active':'')">{{$t('Year')}}</button></div>
					</div>
					<sales-performance-chart ref="sales_avg_chart" v-bind:class="{ 'd-none': !(cash_array && (cash_array.actual))}"></sales-performance-chart>
          <div class="d-flex justify-content-center m-3" v-if="!(cash_array && (cash_array.actual))">
            <b-spinner label="Loading..."></b-spinner>
          </div>
				</div>
			</div>
		</b-col>
	</b-row>

	<b-row>
		<b-col v-if="sales_by_chart_loading || (sales_by_store_chartdata !== null && sales_by_store_chartdata.labels.length > 1) || (sales_by_pos_chartdata !== null && sales_by_pos_chartdata.labels.length > 1)">
			<div class="card-widget">
				<div class="card-widget-content pt-4 pb-3">
					<div class="text-left mb-4">
						<h3 class="font-weight-bold">{{ !!+storeId && (sales_by_pos_chartdata || sales_by_chart_loading) ? $t('Sales by Pos') : $t('Sales by Store') }}</h3>
					</div>
					<div v-if="sales_by_chart_loading" class="d-flex justify-content-center m-3">
						<b-spinner label="Loading..."></b-spinner>
					</div>
					<bar-chart v-if="sales_by_store_chartdata && !sales_by_chart_loading" :chart-data="sales_by_store_chartdata" :options="bar_chart_opt" style="max-height: 30vh;"></bar-chart>
					<bar-chart v-if="sales_by_pos_chartdata && !sales_by_chart_loading" :chart-data="sales_by_pos_chartdata" :options="bar_chart_opt" style="max-height: 30vh;"></bar-chart>
				</div>
			</div>
		</b-col>
	</b-row>



<!-- end: new dashboard -->



    <!-- License comparison modal-->
    <b-modal id="license-compare-modal" size="xl" ok-only :ok-title="$t('Close')" :title="$t('XStore Licenses')">
        <div class="row mx-0 py-3">
            <div class="col col-12 col-xl-4">
                <div class="card p-4">
                    <h3 class="text-black">Personal</h3>
                    <p>{{ $t('La licenza Personal include gratuitamente le funzionalità essenziali di XStore.') }}</p>
                    <small class="text-white">_</small>
                    <h2 class="text-black">{{ $t('Free') }}</h2>
                    <button class="btn btn-primary btn-lg w-100" v-on:click="dismissLicenseModal()">{{ $t('Choose') }}</button>
                    <hr>
                    <h6 class="mb-4 text-black">{{ $t('FUNZIONALITÀ INCLUSE:') }}<br><small class="text-white">_</small></h6>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Visualizzazione del venduto della giornata con evidenza sull’incasso, sul numero di documenti commerciali e di reso emessi.') }}</dd>
                    </dl>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Visualizzazione del venduto per categoria merceologica con evidenza grafica dell’andamento dell’attività e dei prodotti/servizi più redditizi.') }}</dd>
                    </dl>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Consultazione parziale (limitata alla giornata corrente) dello storico dei documenti.') }}</dd>
                    </dl>
                    <dl class="row text-muted mb-0 font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Supporto per un POS.') }}</dd>
                    </dl>
                </div>
            </div>
            <div class="col col-12 col-xl-4">
                <div class="card p-4">
                    <h3 class="text-black">Premium</h3>
                    <p>{{ $t('Con la licenza Premium sfrutti a pieno le potenzialità di XStore.') }}</p>
                    <small>{{ $t('Starting at:') }}</small>
                    <h2><span class="text-black">€60</span><small class="font-sm text-lowercase">/{{ $t('Year') }}</small></h2>
                    <a class="btn btn-primary btn-lg w-100" :href="`${$xmarket_url}/prodotto/licenza-xstore-enterprise`">{{ $t('Buy') }}</a>
                    <hr>
                    <h6 class="mb-4 text-black">{{ $t('FUNZIONI INCLUSE, TUTTE QUELLE DELLA LICENZA PERSONAL E IN AGGIUNTA:') }}</h6>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Consultazione completa, senza limiti temporali, dello storico documenti.') }}</dd>
                    </dl>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Report statistici per categoria, prodotto, IVA e operatore.') }}</dd>
                    </dl>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Supporto di un numero illimitato di POS.') }}</dd>
                    </dl>
                    <dl class="row text-muted font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Gestione dei corrispettivi.') }}</dd>
                    </dl>
                    <dl class="row text-muted mb-0 font-13">
                        <dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
                        <dd class="col">{{ $t('Connessione a CGN.') }}</dd>
                    </dl>
                </div>
            </div>
			<div class="col col-12 col-xl-4">
				<div class="card p-4">
					<h3 class="text-black">Enterprise</h3>
					<p>{{ $t('Con la licenza Enterprise hai accesso a tutte le funzionalità della tua area in Cloud XStore.') }}</p>
					<small>{{ $t('Starting at:') }}</small>
					<h2><span class="text-black">€90</span><small class="font-sm text-lowercase">/{{ $t('Year') }}</small></h2>
					<a class="btn btn-primary btn-lg w-100" :href="`${$xmarket_url}/prodotto/licenza-xstore-enterprise`">{{ $t('Buy') }}</a>
					<hr>
					<h6 class="mb-4 text-black">{{ $t('INCLUDE TUTTE LE FUNZIONALITÀ PREMIUM E INOLTRE:') }}</h6>
					<dl class="row text-muted font-13">
						<dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
						<dd class="col">{{ $t('Esportazione dello storico dei documenti emessi.') }}</dd>
					</dl>
					<dl class="row text-muted font-13">
						<dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
						<dd class="col">{{ $t('Configurazione e gestione da remoto di più cataloghi, associabili anche a diversi punti cassa.') }}</dd>
					</dl>
					<dl class="row text-muted font-13">
						<dt class="col-auto pr-0"><i class="fas fa-check-circle font-2xl text-success"></i></dt>
						<dd class="col">{{ $t('Programmazione da remoto dei punti cassa e dei dispositivi connessi.') }}</dd>
					</dl>
				</div>
			</div>
        </div>
    </b-modal>

</div></template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios'
import vuexStore from '../store'
import CategoryChart from './charts/CategoryChart'
import SalesPerformanceChart from './charts/SalesPerformanceChart'
import Datepicker from 'vuejs-datepicker'
import {de, en, fr, it} from 'vuejs-datepicker/dist/locale';
import moment from 'moment'
import BarChart from "./charts/BarChart";
import DoughnutChart from "./charts/DoughnutChart";
import PieChart from "./charts/PieChart";
import apiHelpers from "../../js/services/apiHelpers";
import licenseHelpers from "../js/licenseHelpers";
import MD5 from "crypto-js/md5";

Date.prototype.addDays = function(days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }


var JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;

    export default {
        name: 'dashboard',
        mixins: [apiHelpers, licenseHelpers],
        components: {
			DoughnutChart,
            BarChart,
			PieChart,
            CategoryChart,
            Datepicker,
            SalesPerformanceChart
        },
        data: () => ({
            invoices_unpaid_count: 0,
            currency_label: null,
            datepickerconfig: {
                dateStart: "",//(new Date()).getTime(),
                dateEnd: ""//(new Date()).getTime()
            },
            it: it,
            en: en,
            de: de,
            fr: fr,
            stores: [],
            pos: [],
            cash: {
                totale: 0,
                docs: 0,
                return_docs: 0,
                return_docs_tot: 0
            },
            cash_array: null,
            alerts : 0,
            alertsItems:[],
            categorie: [],
            opzioni_categorie: {},
            prodotti: [],
            floor: null,
            categoryChartData: null,
            storeId: 0,
            posId: 0,

            rowTableLimit: 5,
            top_prod: null,
            greater_prod: [],

            isBusy: false,
            loading: false,
            showDashboard: false,

            range_chart_st: 'hour',
            range_chart_nd: 'hour',

			categorie_table: [],
			category_display_mode: 'pie',

			cash_array_loading: true,
			sales_by_store_chartdata: null,
			sales_by_pos_chartdata: null,
			sales_by_chart_loading: true,
			bar_chart_opt: {
        legend: { display: false },
				maintainAspectRatio: false,
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				},
			},
			doughnut_chart_opt: {
				maintainAspectRatio: false,
			},
          isFiltersOpen: true,
            e_service_days_active: 0,
            dashboard_config: {
                headers: {
                    'Dashboard-Cache-Key': 'Allowed'
                }
            }
        }),
        computed: {
            ...mapGetters({
                shared_filter: 'search/documents_filters'
            }),
            averageBill: function () {
                // `this` points to the vm instance
                if (this.cash.totale === 0 || this.cash.totale == null) {
                    return 0
                }
                return this.cash.totale / this.cash.docs
            },
            return_docs: function () {
              if (this.cash.return_docs === 0 || this.cash.return_docs == null) {
                return 0
              }
              return this.cash.return_docs
            },
            return_docs_tot: function () {
              if (this.cash.return_docs_tot === 0 || this.cash.return_docs_tot == null) {
                return 0
              }
              return this.cash.return_docs_tot;
            },
            maxProduct: function () {
                var max = 0
                for (var i in this.prodotti) {
                    var item = this.prodotti[i]
                    if (item.quantity > max) {
                        max = item.quantity
                    }
                }
                return max
            },
            totProduct: function () {
                var tot = 0
                for (var i in this.prodotti) {
                    var item = this.prodotti[i]
                    tot += parseInt(item.quantity)
                }
                return tot
            },
            locale: function () {
                return eval('self.it'+ vuexStore.getters.getLanguage.code)
            }

        },
        mounted() {
            let self = this;

            // TODO LICENSES - Remove acl check to unlock extra-IT profiles
            if (!window.localStorage.getItem('freeEntTrialStarted')
                && this.$store.getters.getCustomer?.license?.license_meta?.code === 'trial'
                && this.$store.getters.getAcls.includes('mkt_it')) {
                this.$router.push({name: 'FreePremiumTrial'});
            } else {
                this.showDashboard = true
            }

            // Handle shared filter if enabled
            const today_default = moment().format('YYYY-MM-DD');
            if (this.$store.getters["account/getSetting"]('shared_filters', false)) {
                this.datepickerconfig.dateStart = this.shared_filter?.timestamp_after || today_default;
                this.datepickerconfig.dateEnd = this.shared_filter?.timestamp_before || today_default;
                this.storeId = this.shared_filter?.customer_store_id || 0;
                if (this.storeId) this.loadPOS(this.storeId)
                this.posId = this.shared_filter?.customer_pos_id || 0;
            } else {
                this.datepickerconfig.dateStart = today_default;
                this.datepickerconfig.dateEnd = today_default;
            }

            this.bar_chart_opt.scales = {
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'EUR',
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            if (value === 0) return value;
                            return self.$options.filters.formatPriceExt(value, null, 0);
                        }
                    },
                }]
            }
            this.bar_chart_opt.tooltips = {
                callbacks: {
                    label: function (tooltipItem, data) {
                        let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return self.$options.filters.formatPriceExt(value, self.$store.getters.getCustomer.currency_label);
                    }
                }
            }
            this.currency_label = this.$store.getters.getCustomer.currency_label;
			this.loadInvoicesUnpaidCount();
            this.loadProductsTables();
            this.loadStores();
            this.getAlerts();
            this.getCashArray(null, this.range_chart_st);
            this.salesBy();

            if (this.$store.getters.getAcls.includes('e_invoice')) {
                Promise.resolve(this.$store.dispatch('services/getEInvoiceServiceData')).then(res => {
                    this.e_service_days_active = moment().diff(moment(res.created_at), 'days');
                })
            }

        },
        methods: {
          greater_prod_tooltip_label_cb: function(tooltipItem, data) {
            var label;
            if(tooltipItem && data.labels && data.datasets){
              label = data.labels[tooltipItem.index];

              if (label) {
                label += ': ';
              }

              label += this.$options.filters.formatPriceExt(data.datasets[0].data[tooltipItem.index], this.currency_label)

            }
            return label;
          },
        	salesBy() {
				let self = this
				if (!!+this.posId) {
					this.sales_by_store_chartdata = null
					this.sales_by_pos_chartdata = null
					return;
				}
				this.sales_by_chart_loading = true;
				let store_id = this.storeId
				let url = vuexStore.getters.getAppUrl + '/customer/api/summary/sales-by';
				axios.post(url, {
					start_t: this.formatDate(this.datepickerconfig.dateStart),
					end_t: this.formatDate(this.datepickerconfig.dateEnd),
					store_id: !!+store_id ? self.storeId : undefined,
				}, this.dashboard_config).then(function (response) {
					if (!response.data) return;

					let chartdata = {
						labels: [],
						datasets: [
							{
								backgroundColor: !!+store_id ? '#60bdf8' : '#f87150',
								data: []
							}
						]
					};

					response.data.map((record) => {
						chartdata.labels.push(record.label)
						chartdata.datasets[0].data.push(record.tot)
					})

					if (!!+store_id) {
						self.sales_by_store_chartdata = null;
						self.sales_by_pos_chartdata = chartdata;
					} else {
						self.sales_by_store_chartdata = chartdata;
						self.sales_by_pos_chartdata = null;
					}
					self.sales_by_chart_loading = false;

				}).catch(function (error) {
					console.log(error)
				})
			},
            selectRangeChartSt(value){
                this.range_chart_st = value;
                this.getCashArray('tot', this.range_chart_st);
            },
            selectRangeChartNd(value){
                this.range_chart_nd = value;
                this.getCashArray('avg', this.range_chart_nd);
            },
            customFormatter(date) {
                return moment(date).format('DD/MM/YYYY')
            },
            prodPercent: function (q) {
                return (q * 100 / this.totProduct).toFixed(2) + '%'
            },
            prodBarWidth: function (q) {
                var max = this.maxProduct
                return q * 100 / max + '%'
            },
            loadCash() {
                // Init variables
                this.cash.totale = 0
                this.cash.docs = 0
                this.cash.return_docs = 0
                this.cash.return_docs_tot = 0

                let self = this
                // let appId = 'appkP2oLML51veAbE'
                // let appKey = 'keyJqfYvJLt7spFtt'
                let url = vuexStore.getters.getAppUrl + '/customer/api/summary/cash'
                axios.post(
                    url, {
                        start_t: this.formatDate(this.datepickerconfig.dateStart),
                        end_t: this.formatDate(this.datepickerconfig.dateEnd),
                        operator_id: 1,
                        store_id: this.storeId,
                        pos_id: this.posId,
                        reserved: 1
                    }, this.dashboard_config
                ).then(function (response) {
                    self.cash = response.data
                    self.loadFloor()
                    // this.items = response.data.records
                }).catch(function (error) {
                    console.log(error)
                })
            },
            getCashArray(ref = null, range = 'hour') {
                let self = this
                let url = vuexStore.getters.getAppUrl + '/customer/api/summary/cash-array'
                axios.post(
                    url, {
                        start_t: this.formatDate(this.datepickerconfig.dateStart),
                        end_t: this.formatDate(this.datepickerconfig.dateEnd),
                        operator_id: 1,
                        store_id: this.storeId,
                        pos_id: this.posId,
                        reserved: 1,
                        range: range
                    }, this.dashboard_config
                ).then(function (response) {
                    self.cash_array = response.data;
                    self.cash_array.labels = [];


                    if(self.cash_array && self.cash_array.actual){
                        self.cash_array.actual.forEach(element => {
                            if(range == 'hour'){
                                self.cash_array.labels.push(element.day)
                            }else if(range == 'day' || range == 'week'){
                                self.cash_array.labels.push(element.day.split('-')[2]+"-"+element.day.split('-')[1])
                            }else if(range == 'month'){
                                    self.cash_array.labels.push(element.day.split('-')[1]+"-"+element.day.split('-')[0])
                                }
                        });
                    }

                    if ((!ref || ref=='tot') && self.$refs.sales_tot_chart) {
                        self.$refs.sales_tot_chart.range = self.range_chart_st
                        self.$refs.sales_tot_chart.field = 'tot'
                        self.$refs.sales_tot_chart.fillData(self.cash_array)
                    }
                    if ((!ref || ref=='avg') && self.$refs.sales_avg_chart) {
                        self.$refs.sales_avg_chart.range = self.range_chart_nd
                        self.$refs.sales_avg_chart.field = 'avg'
                        self.$refs.sales_avg_chart.actualPeriodColor = '#6a73ed'
                        self.$refs.sales_avg_chart.fillData(self.cash_array)
                    }
					self.cash_array_loading = false;
                }).catch(function (error) {
                    console.log(error)
                })
            },
            loadFloor() {
                // Init variables
                if (+this.storeId === 0 || +this.posId === 0) {
                    return
                }
                let self = this
                // let appId = 'appkP2oLML51veAbE'
                // let appKey = 'keyJqfYvJLt7spFtt'
                this.items = []
                let url = vuexStore.getters.getAppUrl + '/customer/api/summary/floor'
                axios.post(
                    url, {
                        store_id: this.storeId,
                        pos_id: this.posId
                    }, this.dashboard_config
                ).then(function (response) {
					self.floor = response.data
                    // this.items = response.data.records
                }).catch(function (error) {
                    console.log(error)
                })
            },
            listenToOnStartChangeEvent(selectedDate) {
                //console.log('listenToOnStartChangeEvent ' + selectedDate +" | "+this.datepickerconfig.dateStart +" | "+ typeof this.datepickerconfig.dateStart)
            },
            listenToOnEndChangeEvent(selectedDate) {
                //console.log('listenToOnEndChangeEvent ' + selectedDate +" | "+this.datepickerconfig.EndStart +" | "+ typeof this.datepickerconfig.EndStart)
            },
            formatPrice(value) {
                let val = (value / 1000).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            fillData(catData) {
            	if (this.$refs.foo) {
            		this.$refs.foo.fillData(catData)
				}
            },
            async loadStores() {
                this.isBusy = true;

                this.$store.dispatch("store/loadStores").then((stores) => this.stores = stores);

                this.loadCash()
                this.loadCategories()

                this.isBusy = false;
            },
            deserializeStores: function (jsonApiData) {
                let self = this

                new JSONAPIDeserializer({keyForAttribute: 'underscore_case'}).deserialize(jsonApiData, function (err, stores) {
                    if (err) {
                        console.log(err.stack)
                    }

                    self.stores = stores
                })
            },
            loadCategories() {
                let self = this
                self.categorie = []
                self.prodotti = []
                let url = vuexStore.getters.getAppUrl + '/customer/api/summary/categories'
                axios.post(
                    url, {
                        start_t: this.formatDate(this.datepickerconfig.dateStart),
                        end_t: this.formatDate(this.datepickerconfig.dateEnd),
                        operator_id: 1,
                        store_id: self.storeId,
                        pos_id: self.posId,
                        reserved: 1
                    }, this.dashboard_config
                ).then(function (response) {
                	self.isBusy = false;
                  if (response.data.length) {
                    self.categorie = {
                      datasets: [{
                        data: [],
                        backgroundColor: [],
                      }],
                      labels: []
                    };
					self.categorie_table = [];
                    response.data.forEach((item) => {
						const color = self.getColorFromString(item.description);
                      self.categorie.datasets[0].data.push(item.amount);
                      self.categorie.datasets[0].backgroundColor.push(color);
                      self.categorie.labels.push(item.description || self.$t('Other'));
					  self.categorie_table.push({ label: item.description, amount: item.amount, color  });
                    })
					  self.categorie_table = self.categorie_table.sort((a,b) => b.amount-a.amount).slice(0, 28);
					  if (response.data.length > 10) {
                          self.opzioni_categorie = {
                              legend: {
                                  display: false
                              }
                          };
                      }
                  }
                    // self.fillData(response.data)
                }).catch(function (error) {
                    console.log(error)
                })
            },
            formatDate: function (date) {
                if (date == null) {
                    return null
                }
                return moment(date).format('YYYY-MM-DD')
            },
            loadProducts(category, order_by, limit) {
                this.prodotti.length = 0
                let self = this
                self.isBusy = true;
                this.items = []
                let url = vuexStore.getters.getAppUrl + '/customer/api/summary/products'
                axios.post(
                    url, {
                        start_t: this.formatDate(this.datepickerconfig.dateStart),
                        end_t: this.formatDate(this.datepickerconfig.dateEnd),
                        operator_id: 1,
                        store_id: self.storeId,
                        pos_id: self.posId,
                        category_id: category || null,
                        order_by: order_by || null,
                        limit: limit || null,
                        reserved: 1
                    }, this.dashboard_config
                ).then(function (response) {
                    if(!order_by)
                        self.prodotti = response.data;
                    else if(order_by == 'quantity') {
                    	if (response.data.length) {
							self.top_prod = {
								datasets: [{
									data: [],
									backgroundColor: [],
								}],
								labels: []
							};
							response.data.forEach((item) => {
								self.top_prod.datasets[0].data.push(item.quantity);
								self.top_prod.datasets[0].backgroundColor.push(self.getColorFromString(item.description));
								self.top_prod.labels.push(item.description);
							})
						} else {
                    		self.top_prod = null;
						}
					}
                    else if(order_by == 'cost') {
						if (response.data.length) {
							self.greater_prod = {
								datasets: [{
									data: [],
									backgroundColor: [],
								}],
								labels: []
							};
							response.data.forEach((item) => {
								self.greater_prod.datasets[0].data.push(item.amount);
								self.greater_prod.datasets[0].backgroundColor.push(self.getColorFromString(item.description));
								self.greater_prod.labels.push(item.description);
							})
						} else {
							self.greater_prod = null;
						}
					}
                    // this.items = response.data.records
                    self.isBusy = false;
                }).catch(function (error) {
                    console.log(error)
                })
            },
            goToDevices: function(item) {
                    this.$router.push({name: 'Devices', params: { store_id: item.id, from: 'dashboard'}})
            },
            getAlerts() {
                let alertUrl =  vuexStore.getters.getAppUrl + '/customer/api/alerts/?type=sede'
                axios.get(alertUrl)
                    .then((response) => {
                        let storeAlerts = response.data.stores;

                        let count = 0;
                        for (let i = 0; i < storeAlerts.length; i++) {
                            count = count + storeAlerts[i].alerts;
                        }
                        this.alerts = count;
                        this.alertsItems = storeAlerts;
                        this.updateBadge('Devices', count);
                });
            },
            updateBadge (type,alerts) {
                let menu = this.$store.getters.getMenu;
                menu = menu.map(item => {

                    if (item.name == type) {
                        item.badge.text =alerts;
                    }
                    return item;
                });

                this.$store.commit('setMenu',menu);

            },
            setRange() {
                //console.log(this.datepickerconfig.dateStart + ' - ' + this.datepickerconfig.dateEnd)
                this.loadCash()
                this.loadCategories()
            },
            onStoreChange() {
				this.pos = []
				this.posId = 0
                if (+this.storeId !== 0) this.loadPOS(this.storeId)
            },
            onPOSChange(value) {
				this.posId = value
				this.floor = null
                // console.log('posId = ' + this.posId)
            },
            loadPOS(storeId) {
                this.$store.dispatch("store/loadPossAsSelect", {storeId}).then((poss) => this.pos = poss);
            },
            deserializePos: function (jsonApiData) {
                let self = this

                new JSONAPIDeserializer({keyForAttribute: 'underscore_case'}).deserialize(jsonApiData, function (err, pos) {
                    if (err) {
                        console.log(err.stack)
                    }

                    self.pos = pos
                })
            },
            setFilters: function (){
              this.dashboard_config = {};
                this.setRange();
                this.loadProductsTables();
                this.selectRangeChartSt(this.range_chart_st);
                this.selectRangeChartNd(this.range_chart_nd);
                this.salesBy();

                // Update shared filters if enabled
                if (this.$store.getters["account/getSetting"]('shared_filters', false)) {
                    this.$store.commit('search/updateDocumentsFilters', {
                        timestamp_after: this.datepickerconfig.dateStart,
                        timestamp_before: this.datepickerconfig.dateEnd,
                        customer_store_id: this.storeId,
                        customer_pos_id: this.posId,
                    });
                }
            },
            loadProductsTables: function (){
                this.loadProducts(null, 'quantity', this.rowTableLimit);
                this.loadProducts(null, 'cost', this.rowTableLimit);
            },

            selectPreRange(range){
                switch (range) {
                    case "today":
                        this.datepickerconfig.dateStart = moment().format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().format('YYYY-MM-DD');
                        break;
                    case "yesterday":
                        this.datepickerconfig.dateStart = moment().subtract(1, 'day').format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().subtract(1, 'day').format('YYYY-MM-DD');
                        break;
                    case "this_week":
                        this.datepickerconfig.dateStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().endOf('isoWeek').format('YYYY-MM-DD');
                        break;
                    case "this_month":
                        this.datepickerconfig.dateStart = moment().startOf('month').format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().endOf('month').format('YYYY-MM-DD');
                        break;
                    case "last_month":
                        this.datepickerconfig.dateStart = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
                        break;
                    case "this_year":
                        this.datepickerconfig.dateStart = moment().startOf('year').format('YYYY-MM-DD');
                        this.datepickerconfig.dateEnd = moment().endOf('year').format('YYYY-MM-DD');
                        break;
                    default:
                        break;
                }

                this.setFilters();
            },
            greaterProdAmountRound(amount){
                amount = +amount;
                return Math.round(amount/10)/100;
            },

            getRandomColor: function () {
              const r = (Math.round(Math.random() * 127) + 127).toString(16)
              const g = (Math.round(Math.random() * 127) + 127).toString(16)
              const b = (Math.round(Math.random() * 127) + 127).toString(16)
              return '#' + r + g + b
            },
            getColorFromString: function (str) {
              return '#'+this.intToRGB(this.hashCode(MD5(str).toString()));
            },
            hashCode: function (str) {
              var hash = 0;
              for (var i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
              }
              return hash;
            },
            intToRGB: function (i){
              var c = (i & 0x00FFFFFF)
                .toString(16)
                .toUpperCase();

              return "00000".substring(0, 6 - c.length) + c;
            },
            addDaysToDate(date, days){
                date.setDate(date.getDate() + days);
                return date;
            },
            toggleFilters(){
              this.isFiltersOpen = !this.isFiltersOpen;
            },
            dismissLicenseModal(){
              this.$bvModal.hide('license-compare-modal');
              if (this.isTrialLicenseExpiring() && this.available_alert_ids.includes('xstore_license_trial_expiring')) {
                  this.dismissLicenseAlert('xstore_license_trial_expiring')
              }
              if (this.isTrialLicenseExpired() && this.available_alert_ids.includes('xstore_license_trial_expired')) {
                  this.dismissLicenseAlert('xstore_license_trial_expired')
              }
            },
            loadInvoicesUnpaidCount() {
                let url = this.$store.getters.getAppUrl + '/customer/api/v2/invoices-stats/unpaid-count'
                axios.get(url).then(({ data }) => {
                    this.invoices_unpaid_count = data.unpaid_count;
                }).catch(function () {
                    this.$notify(error());
                })
            }
        }
    }
</script>
<style scoped>
	.form-sticky {
    margin-bottom: 0.5rem;
	}
	.form-absolute {
    margin-bottom: 0.5rem;
	}
  .alert, .stats{
    margin-bottom: 0px;
    height: 100%;
  }
  .filter-submit-button{
    max-width: 180px;
  }
  .collapse-toggle-container{
    border-bottom: 2px solid #f9f9fc;
    padding: 10px;
  }
  /** filter-submit-button-col */
  /** center-filter-col */
  /** quick-filters */
  @media (min-width: 576px){ /*sm*/
  }
  @media (min-width: 768px){ /*md*/
    .form-sticky {
      margin-top: 3rem;
    }
    .form-absolute {
      margin-top: 3rem;
    }
  }
  @media (min-width: 771px){ /*md*/
    .form-sticky {
      margin-top: 0rem;
    }
    .form-absolute {
      margin-top: 0rem;
    }
  }
  @media (min-width: 992px) { /*lg*/
    .form-sticky-container{
      padding-right: 15px;
      padding-left: 15px;
    }
    .form-sticky {
      position: fixed;
      top: 0;
      z-index: 99;
      right: 0;
      left: 0;
      margin: 6rem 2rem;
    }
    .form-absolute {
      position: absolute;
      top: 0;
      z-index: 99;
      right: 0;
      left: 0;
      margin: 6rem 2rem;
    }
    .after-fixed-row{
      margin-top: 10rem;
    }
  }
  @media (min-width: 1200px){ /*xl*/
    .center-filter-col{
      width: 1380px;
    }
    .after-fixed-row{
      margin-top: 10rem;
    }
  }
  @media (min-width: 1600px){ /*xl - xxl*/
    .after-fixed-row{
      margin-top: 8rem;
    }
    .col-xl-12{
      lex: 0 0 16.66666667%;
      max-width: 16.66666667%;
    }
  }
  @media (min-width: 2150px){ /*xxl*/
    .after-fixed-row{
      margin-top: 8rem;
    }
    .col-xl-12{
      lex: 0 0 16.66666667%;
      max-width: 16.66666667%;
    }
  }
  @media (min-width: 2302px){ /*xxxl*/
    .center-filter-col{
      width: 1380px;
    }
    .after-fixed-row{
      margin-top: 5rem;
    }
    .col-xl-12{
      lex: 0 0 16.66666667%;
      max-width: 16.66666667%;
    }
    .col-xl-8{

    }
    .col-xl-2{

    }

  }
  * {
    transition: none;
    will-change: all;
  }
    .custom.alert.alert-success, .btn-success {
        background: #1dc95c;
        border: 1px solid #1dc95c;
        color: #fff;
    }
    .custom.alert.alert-info, .btn-info {
         background: #2786fb;
         border: 1px solid #2786fb;
         color: #fff;
     }
    .custom.alert.alert-warning, .btn-warning {
         background: #ffb822;
         border: 1px solid #ffb822;
         color: #111;
     }
    .custom.alert.alert-danger, .btn-danger {
         background: #e01c1c;
         border: 1px solid #e01c1c;
         color: #fff;
     }
</style>
